import { render, staticRenderFns } from "./ArticleList.vue?vue&type=template&id=0b6a47f7&scoped=true&"
import script from "./ArticleList.vue?vue&type=script&lang=ts&"
export * from "./ArticleList.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleList.vue?vue&type=style&index=0&id=0b6a47f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6a47f7",
  null
  
)

export default component.exports